<script setup lang="ts">
import { useMockupEditorStore } from '@/stores/mockupEditor'

const store = useMockupEditorStore()
</script>

<template>
  <div class="logo">
    <img
      class="logo__img"
      src="/animock-logo.png"
      :alt="store.tUi('brand.logoAria')"
      width="32"
      height="32"
      decoding="async"
    />
    <span class="logo__text">Animock</span>
  </div>
</template>

<style scoped>
.logo {
  display: inline-flex;
  align-items: center;
  user-select: none;
}

/**
 * 品牌图形标识：与顶栏行高对齐，宽度随比例缩放。
 */
.logo__img {
  display: block;
  height: 1.75rem;
  width: auto;
  border-radius: 10px;
}

.logo__text {
  padding-left: 0.5rem;
  font-size: 1rem;
  font-weight: 700;
  color: var(--im-text);
  letter-spacing: 0.01em;
}
</style>
